import { StockRoutingModule } from './stock-routing.module';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { StockFormComponent } from './stock-form/stock-form.component';
import { StockDetailComponent } from './stock-detail/stock-detail.component';
import { StockComponent } from './stock-list/stock-list.component';

@NgModule({
    declarations: [
        StockFormComponent,
        StockDetailComponent,
        StockComponent
    ],
    imports: [
      SharedModule,
      StockRoutingModule
    ]
  })
  export class StockModule { }